<template>
<v-card v-if="dashboard">
    <v-card-title class="subtitle-1 pr-2">
        <v-icon color="purple lighten-3" class="mr-3">mdi-truck</v-icon>배송관리
    </v-card-title>
    <v-card-text>
        <v-responsive height="64">
            <v-row>
                <v-col cols="auto" class="py-0">배송중</v-col>
                <v-spacer />
                <v-col cols="auto" class="py-0">
                    <v-btn class="purple--text text--lighten-3 font-weight-bold mr-1 pa-0" min-width="auto" height="auto" text @click="$router.push('/console/shop/purchases/delivery?orderStatus=shipping-confirm&claimStatus=null&claimStatus=cancel-reject')">{{ dashboard.shippingConfirm.format() }}</v-btn>건
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="auto" class="py-0">배송완료</v-col>
                <v-spacer />
                <v-col cols="auto" class="py-0">
                    <v-btn class="purple--text text--lighten-3 font-weight-bold mr-1 pa-0" min-width="auto" height="auto" text @click="$router.push('/console/shop/purchases/delivery?orderStatus=delivery-complete&claimStatus=null&claimStatus=cancel-reject&claimStatus=exchange-reject&claimStatus=return-reject')">{{ dashboard.deliveryComplete.format() }}</v-btn>건
                </v-col>
            </v-row>
        </v-responsive>
    </v-card-text>
</v-card>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            dashboard: null
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search()
        },
        async search(){
            try{
                var { dashboard } = await api.console.shop.purchases.getDashboard({ manage: "all" })
                this.dashboard = dashboard;
            }
            catch(error){
                console.error(error);
            }
        }
    }
}
</script>
